// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/cadulis/ngx-toasty
import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import * as ɵngcc0 from '@angular/core';
export * from './src/toasty.service';
export * from './src/toasty.component';
export * from './src/toast.component';
export * from './src/shared';
import { ToastyComponent } from './src/toasty.component';
import { ToastComponent } from './src/toast.component';
import { SafeHtmlPipe } from './src/shared';
import { ToastyService, ToastyConfig, toastyServiceFactory } from './src/toasty.service';
export var providers = [
    ToastyConfig,
    { provide: ToastyService, useFactory: toastyServiceFactory, deps: [ToastyConfig] }
];
var ToastyModule = (function () {
    function ToastyModule() {
    }
    ToastyModule.forRoot = function () {
        return {
            ngModule: ToastyModule,
            providers: providers
        };
    };
    /** @nocollapse */
    ToastyModule.ctorParameters = function () { return []; };
ToastyModule.ɵfac = function ToastyModule_Factory(t) { return new (t || ToastyModule)(); };
ToastyModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ToastyModule });
ToastyModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: providers, imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastyModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [ToastComponent, ToastyComponent, SafeHtmlPipe],
                exports: [ToastComponent, ToastyComponent],
                providers: providers
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ToastyModule, { declarations: function () { return [ToastComponent, ToastyComponent, SafeHtmlPipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ToastComponent, ToastyComponent]; } }); })();
    return ToastyModule;
}());
export { ToastyModule };

